import type { Database } from '@/integrations/supabase/types';

type Profile = Database['public']['Tables']['profiles']['Row'];

/**
 * Generate a personalized savings estimate based on the user's case data.
 * Used in paywall and usage gate modals to increase conversion.
 */
export function getPersonalizedSavings(profile: Profile | null): string {
  if (!profile) return 'Save thousands compared to traditional divorce costs';

  const complexity = profile.complexity_level;
  const state = profile.state;

  if (complexity === 'high' || complexity === 'complex') {
    return `Based on your ${state || ''} case, upgrading could save you an estimated $15,000+`.replace('  ', ' ').trim();
  } else if (complexity === 'moderate' || complexity === 'medium') {
    return `Protect your interests \u2014 users in ${state || 'your state'} save an average of $10,000`;
  } else {
    return 'Get AI-powered strategy for less than 1 hour of attorney time';
  }
}
